export default "__VITE_ASSET__DJJjCdiQ__"